import React, { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import TopBar from '../Common/TopBar';
import NewsManagement from './NewsManagement';
import FcmManagement from './FcmManagement';
import DirectMessage from './DirectMessage';
import TopicManagementPage from './TopicManagementPage';
import CountryManagement from './CountryManagement';
import SettingsManagement from './SettingsManagement';
import './Dashboard.css';

const Dashboard = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="dashboard">
      <TopBar />
      <button className="mobile-menu-button" onClick={toggleSidebar}>
        ☰
      </button>
      <div className="dashboard-container">
        <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />
        <div className="dashboard-content">
          <Routes>
            <Route path="/" element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="/news" element={<NewsManagement />} />
            <Route path="/fcm" element={<FcmManagement />} />
            <Route path="/direct-message" element={<DirectMessage />} />
            <Route path="/topics" element={<TopicManagementPage />} />
            <Route path="/hot-topics" element={<Navigate to="/admin/topics" replace />} />
            <Route path="/countries" element={<CountryManagement />} />
            <Route path="/settings" element={<SettingsManagement />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
